module.exports = __webpack_public_path__ + "img/crown-white.d5305f5c.svg";